import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Spacing, BannerWidth, DEFAULT_SPACING, DEFAULT_BANNER_WIDTH } from './banner-wrapper.types';

// See ./CLAUDE.md for the full spec (spacing scale, tokens, swiper usage).
@Component({
  selector: 'app-banner-wrapper',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tw-block',
    '[class.tw-mx-4]': 'isInset()',
    '[class.tw-my-small]': 'isSpacingSmall()',
    '[class.tw-my-medium]': 'isSpacingMedium()',
    '[class.tw-my-large]': 'isSpacingLarge()',
  },
})
export class BannerWrapperComponent {
  width = input<BannerWidth>(DEFAULT_BANNER_WIDTH);
  spacing = input<Spacing>(DEFAULT_SPACING);

  protected readonly isInset = computed((): boolean => this.width() === BannerWidth.Inset);
  protected readonly isSpacingSmall = computed((): boolean => this.spacing() === Spacing.Small);
  protected readonly isSpacingMedium = computed((): boolean => this.spacing() === Spacing.Medium);
  protected readonly isSpacingLarge = computed((): boolean => this.spacing() === Spacing.Large);
}
